import axios from "axios";
import { setToken, setUserInfo, getUserInfo, getToken } from "@/utils";

const baseURL = process.env.VUE_APP_BASE_API
// تعريف مثيل baseApi
const baseApi = axios.create({ baseURL });

// 添加请求拦截器
baseApi.interceptors.request.use(
	config => {
		const token = getToken(); // 从本地存储获取 token
		if (token) {
			config.headers['token'] = `${token}`; // 将 token 添加到请求头
		}
		console.log(config)
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 添加响应拦截器
baseApi.interceptors.response.use(
	response => {
		// 如果响应是失败且是用户错误，清空用户信息
		if (response.data && response.data.code === 'failed') {

			if (response.config.url.includes("broad.jspx")) {
				// 清空用户信息
				localStorage.removeItem('token');
				localStorage.removeItem('userInfo');
				console.log("window.location.pathname====>", "window.location.pathname")
				window.location.href = '/login?redirect=' + window.location.pathname;
			}
		}
		return response;
	},
	error => {
		// 处理响应错误
		console.error('Response Error:', error);
		return Promise.reject(error);
	}
);

export const registerUser = async (params) => {
	const formData = new FormData(); // 创建 FormData 实例
	formData.append('password', params.password); // 添加 pageSize
	formData.append('email', params.email); // 添加 currency
	formData.append('currency', params.currency); // 添加 currency
	try {
		const response = await baseApi.post("/interface/arvh5/register.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data;
	} catch (error) {
		console.error("خطأ:", error);
		throw error;
	}
};

export const loginUser = async (params) => {
	const formData = new FormData(); // 创建 FormData 实例
	formData.append('password', params.password); // 添加 pageSize
	formData.append('username', params.username); // 添加 currency
	const response = await baseApi.post("/interface/arvh5/login.jspx", formData, {
		headers: {
			'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
		}
	});
	setToken(response.data.token);
	setUserInfo(response.data);
	return response.data;
};

export const refreshToken = async () => {
	const userid = getUserInfo()?.userId;
	console.log(getUserInfo(), "getUserInfo()")
	console.log(userid, "userid")
	const response = await baseApi.get("/api/token/renew.jspx", {
		params: {
			userId: userid
		}
	});
	setToken(response.data.token);
	return response.data;
};


export const loadMoreMovies = async (pageNo, pageSize) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('pageNo', pageNo); // 添加 pageNo
		formData.append('pageSize', pageSize); // 添加 pageSize
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/video/list.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};



export const search = async (words, pageNo, pageSize) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('words', words); // 添加 pageNo
		formData.append('pageNo', pageNo); // 添加 pageNo
		formData.append('pageSize', pageSize); // 添加 pageSize
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/search.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};

export const banners = async () => {
	try {

		const response = await baseApi.post("/api/arvh5/banners.jspx", {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};




export const getMovieDetail = async (id) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('id', id); // 添加 pageNo
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/video/detail.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};
export const getPlayDetail = async (id) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('id', id); // 添加 pageNo
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/video/broad.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};


export const getPrice = async (id) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('id', id); // 添加 pageNo
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/video/price.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};

export const signalOrder = async (ids) => {
	try {
		const formData = new FormData();
		ids.forEach(id => formData.append('ids', id));
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post(`/api/arvh5/detailOrder.jspx`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};



export const vipOrder = async (vipId, proId) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('vipId', vipId); // 添加 pageNo
		formData.append('proId', proId); // 添加 pageNo
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency

		const response = await baseApi.post("/api/arvh5/vipOrder.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};


export const pay = async (orderId, ps) => {
	console.log(ps, "ps")
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('code', "paymentwall"); // 添加 pageNo
		formData.append('orderId', orderId); // 添加 pageNo
		formData.append('currency', getUserInfo()?.currency || 'USD'); // 添加 currency
		formData.append('couponld', '0'); // 添加 currency
		formData.append('ps', ps || 'mint'); // 添加 currency
		formData.append('successUrl', window.location.href); // 添加 currency
		const response = await baseApi.post("/api/paymentwall/pay.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};
export const orders = async (pageNo, pageSize) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('pageNo', pageNo); // 添加 pageNo
		formData.append('pageSize', pageSize); // 添加 pageNo
		const response = await baseApi.post("/api/arvh5/orders.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};
export const views = async (pageNo, pageSize) => {
	try {
		const formData = new FormData(); // 创建 FormData 实例
		formData.append('pageNo', pageNo); // 添加 pageNo
		formData.append('pageSize', pageSize); // 添加 pageNo
		const response = await baseApi.post("/api/arvh5/views.jspx", formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
			}
		});
		return response.data; // 假设返回的数据格式是一个电影列表
	} catch (error) {
		console.error("加载更多电影时出错:", error);
		throw error;
	}
};

export const makePayment = async () => {
	try {
		const response = await baseApi.post("/api/arvh5/payments.jspx");
		return response.data; // 返回响应数据
	} catch (error) {
		console.error("支付请求出错:", error);
		throw error; // 抛出错误以便调用者处理
	}
};


